import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { BaseRichService } from '../../../providers/base-rich.service';
import { BaseListComponent } from '../../shared/base-list/base-list.component';

@Component({
  selector: 'app-speedtest',
  templateUrl: '../../shared/base-list/base-list.component.html',
  styleUrls: ['./speedtest.component.scss', '../../shared/base-list/base-list.component.scss']
})
export class SpeedtestComponent extends BaseListComponent implements OnInit, OnChanges {

  @Input() userid: any;

  constructor(
    public cookieService: CookieService,
    public activeModal: NgbModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: BaseRichService,
  ) {
    super(cookieService, activeModal, titleService, translator, service);
    this.entity = 'speed_test';
  }

  getBody(): any {
    const body = super.getBody();
    if (this.userid) {
      if (body.query) {
        body.query = [body.query, 'and', ['user_id', '=', this.userid]];
      } else {
        body.query = ['user_id', '=', this.userid];
      }
    }
    return body;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.userid && this.meta) {
      this.load();
    }
  }

}
